var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C9 1.175 9.675 0.5 10.5 0.5C11.325 0.5 12 1.175 12 2C12 2.825 11.325 3.5 10.5 3.5C9.675 3.5 9 2.825 9 2ZM4.5 2C4.5 1.175 5.175 0.5 6 0.5C6.825 0.5 7.5 1.175 7.5 2C7.5 2.825 6.825 3.5 6 3.5C5.175 3.5 4.5 2.825 4.5 2ZM0 2C0 1.175 0.675 0.5 1.5 0.5C2.325 0.5 3 1.175 3 2C3 2.825 2.325 3.5 1.5 3.5C0.675 3.5 0 2.825 0 2Z",
    fill: "#7F8BFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.1ecd6d776ac4794d960f442e656ebb68.svg";
export { ForwardRef as ReactComponent };